<template></template>

<script>
import L from 'leaflet'
import 'leaflet.heat'
export default {
    props: {
        options: {
            type: Object,
            default: function () {
                return {}
            }
        },
        latLng: {
            default: function () {
                return []
            }
        }
    },
    watch: {
        url () {
            this.updateLayer()
        },
        options () {
            this.updateLayer()
        }
    },
    mounted () {
        this.mapObject = L.heatLayer(this.latLng, this.options)
        if (this.options) {
            L.DomEvent.on(this.mapObject, this.$listeners)
        }
        if (this.$parent._isMounted) {
            this.deferredMountedTo(this.$parent.mapObject)
        }
    },
    beforeDestroy () {
        this.removeLayer()
    },
    methods: {
        deferredMountedTo(parent) {
            this.mapObject.addTo(parent)
        },

        removeLayer() {
            this.$parent.mapObject.removeLayer(this.mapObject);
        },

        updateLayer() {
            this.removeLayer()
            this.mapObject = L.heatLayer(this.latLng, this.options)
            this.deferredMountedTo(this.$parent.mapObject);
        }
    }

}
</script>
